<ng-template #template let-row="row">
  <div
    class="project-address-cell"
    [matTooltip]="row?.address ? row?.fullAddress : ''"
    matTooltipPosition="above"
    matTooltipShowDelay="1000"
  >
    <span class="pii">{{ row?.address ? row?.fullAddress : '-' }}</span>
  </div>
</ng-template>
